import axios from 'axios'

type SectionListItem = {key: string; title: string}
type RenderResponse = {status: number; data?: {html?: string}}

const RAW_BASE_URL = (import.meta as any).env?.VITE_SITE_BASE || 'https://kworum-site.meowbox.ru/'
const BASE_URL = RAW_BASE_URL.replace(/\/+$/, '') + '/api/site'

export const siteClient = axios.create({
    baseURL: BASE_URL,
    headers: {'Content-Type': 'application/json'},
    withCredentials: false,
})

/**
 * Получить список доступных секций.
 */
export async function fetchSectionList(): Promise<SectionListItem[]> {
    const {data} = await siteClient.post('/sections/list', {})
    if (Number(data?.status) !== 200) throw new Error(String(data?.data || 'sections/list failed'))
    return data.data || []
}

/**
 * Получить метаданные секции.
 */
function keyToString(key: any): string {
    if (typeof key === 'string') return key
    if (key && typeof key === 'object') return key.value ?? key.key ?? key.id ?? ''
    return ''
}

export async function fetchSectionMeta(key: string | any): Promise<any> {
    const safeKey = keyToString(key)
    const {data} = await siteClient.post('/sections/meta', {key: safeKey})
    if (Number(data?.status) !== 200) throw new Error(String(data?.data || 'sections/meta failed'))
    return data.data || {}
}

/**
 * Сгенерировать HTML превью секции (c CSS внутри <head>).
 * Можно передать inlineCss = true, чтобы локальные стили были инлайном.
 */
export async function renderSectionHtml(
    key: string,
    value: any,
    inlineCss = false
): Promise<string> {
    const {data} = await siteClient.post<RenderResponse>('/sections/render', {
        key,
        value,
        inline_css: inlineCss,
    })
    if (Number(data?.status) !== 200)
        throw new Error(String((data as any)?.data || 'sections/render failed'))
    return data?.data?.html || ''
}

export async function uploadImage(file: File) {
    const base = (import.meta as any).env?.VITE_SITE_BASE || 'https://kworum-site.meowbox.ru/'
    const url = base.replace(/\/+$/, '') + '/api/site/assets/upload'

    const fd = new FormData()
    fd.append('file', file)

    return axios
        .post(url, fd, {
            headers: {
                /* БЕЗ Content-Type — его проставит браузер */
            },
            withCredentials: false,
        })
        .then((r) => r.data)
}
